<div [ngClass]="{'settings-item-dark': darkBgMode}" class="mb-3 settings-item">
  <h5 *ngIf="!(vehicleFeatures)" class="mb-3" translate>global.features</h5>
  <ng-container *ngFor="let feature of features">
    <div *ngIf="!(vehicleFeatures && feature.isDisabled)">
      <div *ngIf="isFeatureVisible(feature.name)" class="mb-4">
        <div class="d-flex justify-content-between">
          <div class="w-100 d-flex align-items-center">
            <img *ngIf="feature.icon" style="max-width: 100%; height: 25px; width: 25px;" class="mr-3 feature-icon"
              [src]="feature.icon" alt="">
            <p>{{feature.displayName}}</p>
          </div>
          <div style="position: relative;" (click)="showMessage(feature)" class="row">
            <div class="choose-window">
              <p *ngIf="!vehicleFeatures" translate>user.disable</p>
              <label class="switch">
                <input type="checkbox"
                  [disabled]="feature.isDisabled || currentUser?.readOnlyPermissions || feature.name === 'platform_360'"
                  [ngModel]="feature.isChecked" (click)="patchFeature($event, feature)">
                <span class="slider round"></span>
              </label>
              <p *ngIf="!vehicleFeatures" translate>user.enable</p>
            </div>

          </div>
        </div>
        <div *ngIf="feature.name === 'platform_360'" class="small mt-2" translate>settings.feature360Info</div>
      </div>
    </div>
  </ng-container>
</div>